import { apiRequest } from '../axiosInstance';
import axiosInstance from '../axiosInstance';
import { LICENSE_PLAN_ENDPOINTS, buildQueryString } from '../endpoints';

const licensePlanService = {
  getPlans: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${LICENSE_PLAN_ENDPOINTS.LIST}${queryString}`)
    );
  },

  getPlanById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(LICENSE_PLAN_ENDPOINTS.GET_BY_ID(id))
    );
  },

  createPlan: async (planData) => {
    return apiRequest(() =>
      axiosInstance.post(LICENSE_PLAN_ENDPOINTS.CREATE, planData)
    );
  },

  updatePlan: async (id, planData) => {
    return apiRequest(() =>
      axiosInstance.put(LICENSE_PLAN_ENDPOINTS.UPDATE(id), planData)
    );
  },

  deletePlan: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(LICENSE_PLAN_ENDPOINTS.DELETE(id))
    );
  },

  setDefault: async (id) => {
    return apiRequest(() =>
      axiosInstance.post(LICENSE_PLAN_ENDPOINTS.SET_DEFAULT(id))
    );
  },
};

export default licensePlanService;
